import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Popconfirm, Table} from "antd";
import {Edit, Edit2, Menu as MENU, Trash2, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import {RiEjectLine} from "react-icons/ri";
import {BiCheckDouble} from "react-icons/bi";
import {MdDone} from "react-icons/md";

export default function Ceilings() {
    const history = useHistory();
    const [usersData, setUsersData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);
    useEffect(() => {
        LoadWalls();
    }, []);

    const LoadWalls = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadCeilings");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setUsersData(result.data);
                            setFilterData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const handleSearch = (value) => {
        if (value) {
            const filtered = filterData.filter((item) => item.Ceiling.toLowerCase().includes(value.trim().toLowerCase()) || item.FireResistance.toLowerCase().includes(value.trim().toLowerCase()));
            setUsersData(filtered);
        } else {
            setUsersData(filterData);
        }

    };

    async function deleteWall(id) {
        let toaster;
        toaster = toast.loading("Processing...");
        try {
            const formdata = new FormData();
            formdata.append("page", "DeleteCeiling");
            formdata.append("id", id);
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    if (result.status === 1) {
                        setTimeout(() => {
                            toast.update(toaster, {
                                type: "success",
                                render: "Record Deleted!",
                                isLoading: false,
                                autoClose: toaster,
                                closeButton: true,
                                pauseOnHover: false,
                                pauseOnFocusLoss: false,
                            })

                        }, 1000)
                        LoadWalls();
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                })
                .catch(error => console.log('error', error));
        } catch (e) {
            console.log(e);
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16}/>
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                            onClick={() => setIsMobileShow(false)}>
                        <X size={16}/>
                    </button>
                    <h2>Ceilings</h2>
                    <span>want to manage the ceilings?</span>
                    <div className="content-card">
                        <div className="table-search">
                            <input type="search" placeholder='Type to search...'
                                   onChange={(e) => handleSearch(e.target.value)}/>
                            <div>
                                <button className='btn-card-header' style={{marginRight: 5}}
                                        onClick={() => history.push('/user/add-ceiling',{data : null})}>Add
                                    Ceiling
                                </button>
                                <button className='btn-card-header'
                                        onClick={() => history.push('/user/add-ceiling-select')}>Add
                                    Ceilings Select
                                </button>
                            </div>
                        </div>
                        <Table dataSource={usersData} pagination={{pageSize: 10}}
                               loading={isLoading}
                               rowHoverable={true} style={{marginTop: 40}}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }}/>
                            <Table.Column title="Ceiling" dataIndex="Ceiling"/>
                            <Table.Column title="Fire Resistance" dataIndex="FireResistance"/>
                            <Table.Column title="Acoustic Rating" render={(r) => {
                                return <span>{r.AcousticRating} <br/> {r.AcousticRating1}</span>
                            }}/>
                            <Table.Column title="Widht/Depth (mm)" dataIndex="WidthDepth"/>
                            <Table.Column title="Pressure" dataIndex="Pressure"/>
                            <Table.Column title="Stud (mm)" dataIndex="Stud"/>
                            <Table.Column title="System Number" dataIndex="SystemNo"/>
                            <Table.Column title="First Lining" dataIndex="FirstLining"/>
                            <Table.Column title="Second Lining" dataIndex="SecondLining"/>
                            <Table.Column title="Third Lining" dataIndex="ThirdLining"/>
                            <Table.Column title="Flooring/Roofing Type" dataIndex="FlooringType"/>
                            <Table.Column title="Ceiling Fixing Type" dataIndex="CeilingFixingType"/>
                            <Table.Column title="Reference" dataIndex="Ref"/>
                            <Table.Column title="Top Lining" dataIndex="TopLining"/>
                            <Table.Column title="Bottom Lining" dataIndex="BottomLining"/>
                            <Table.Column title="Insulation" dataIndex="Insulation"/>
                            <Table.Column title="Date" dataIndex="Date"/>
                            <Table.Column title="Edit" render={(j) => {
                                return (
                                    <Button type='primary' icon={<Edit2 size={15}/>} onClick={() => {
                                        history.push("/user/add-ceiling", {data: j})
                                    }}/>
                                )
                            }}/>
                            <Table.Column title="Delete" render={(j) => {
                                return (
                                    <Popconfirm title={'Are you sure?'}
                                                description={'You want to remove this wall?'}
                                                onConfirm={() => {
                                                    deleteWall(j.id)
                                                }}
                                    >
                                        <Button type='primary' danger icon={<Trash2 size={15}/>}/>
                                    </Popconfirm>
                                )
                            }}/>


                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
